import { lazy } from 'react';

// ---------- Public pages (non-landing, non-auth) ----------
export const Index = lazy(() => import('@/pages/Index'));
export const ForgotPassword = lazy(() => import('@/pages/ForgotPassword'));
export const ResetPassword = lazy(() => import('@/pages/ResetPassword'));
export const Invite = lazy(() => import('@/pages/Invite'));
export const DesignPartners = lazy(() => import('@/pages/DesignPartners'));
export const OurStory = lazy(() => import('@/pages/OurStory'));
export const HiddenCostArticle = lazy(() => import('@/pages/blog/HiddenCostArticle'));
export const Unsubscribe = lazy(() => import('@/pages/Unsubscribe'));
export const PrivacyPolicy = lazy(() => import('@/pages/PrivacyPolicy'));
export const TermsOfService = lazy(() => import('@/pages/TermsOfService'));
export const SecurityPolicy = lazy(() => import('@/pages/SecurityPolicy'));
export const SubProcessors = lazy(() => import('@/pages/SubProcessors'));
export const Pricing = lazy(() => import('@/pages/Pricing'));

// ---------- Core protected pages ----------
export const Dashboard = lazy(() => import('@/pages/Dashboard'));
export const GettingStarted = lazy(() => import('@/pages/GettingStarted'));
export const Events = lazy(() => import('@/pages/Events'));
export const Calendar = lazy(() => import('@/pages/Calendar'));
export const Hyped = lazy(() => import('@/pages/Hyped'));
export const Onboarding = lazy(() => import('@/pages/Onboarding'));
export const GMReportPage = lazy(() => import('@/pages/events/GMReportPage'));
export const ReportsPage = lazy(() => import('@/pages/reports/ReportsPage'));
export const Insights = lazy(() => import('@/pages/Insights'));
export const Settings = lazy(() => import('@/pages/Settings'));
export const Team = lazy(() => import('@/pages/Team'));

// ---------- Marketing pages ----------
export const MarketingOverview = lazy(() => import('@/pages/marketing/MarketingOverview'));
export const MarketingEmail = lazy(() => import('@/pages/marketing/MarketingEmail'));
export const MarketingSmsPage = lazy(() => import('@/pages/marketing/MarketingSmsPage'));
export const MarketingAudiencesPage = lazy(
  () => import('@/pages/marketing/MarketingAudiencesPage'),
);
export const MarketingMetaAds = lazy(() => import('@/pages/marketing/MarketingMetaAds'));
export const MarketingInstagramGrowth = lazy(
  () => import('@/pages/marketing/MarketingInstagramGrowth'),
);
export const MarketingSettingsPage = lazy(() => import('@/pages/marketing/MarketingSettingsPage'));
export const MarketingDistribution = lazy(() => import('@/pages/marketing/MarketingDistribution'));

// ---------- Analytics pages ----------
export const AnalyticsLayout = lazy(() => import('@/pages/analytics/AnalyticsLayout'));
export const EventOverlayDashboard = lazy(() => import('@/pages/analytics/EventOverlayDashboard'));
export const MetaAdsDashboard = lazy(() => import('@/pages/analytics/MetaAdsDashboard'));
export const GoogleAdsDashboard = lazy(() => import('@/pages/analytics/GoogleAdsDashboard'));
export const SocialPerformanceDashboard = lazy(
  () => import('@/pages/analytics/SocialPerformanceDashboard'),
);

// ---------- Account pages ----------
export const AccountLayout = lazy(() => import('@/pages/account/AccountLayout'));
export const ContactInfo = lazy(() => import('@/pages/account/ContactInfo'));
export const ChangeEmail = lazy(() => import('@/pages/account/ChangeEmail'));
export const Password = lazy(() => import('@/pages/account/Password'));
export const PaymentMethods = lazy(() => import('@/pages/account/PaymentMethods'));
export const LinkedAccounts = lazy(() => import('@/pages/account/LinkedAccounts'));
export const CommunicationPreferences = lazy(
  () => import('@/pages/account/CommunicationPreferences'),
);
export const CloseAccount = lazy(() => import('@/pages/account/CloseAccount'));
export const PersonalData = lazy(() => import('@/pages/account/PersonalData'));

// ---------- CRM / VIP pages ----------
export const VIPDashboard = lazy(() => import('@/pages/crm/VIPDashboard'));
export const VIPProfilePage = lazy(() => import('@/pages/crm/VIPProfilePage'));
export const VIPSettingsPage = lazy(() => import('@/pages/crm/VIPSettings'));

// ---------- Admin pages ----------
export const DemoDataAdmin = lazy(() => import('@/pages/admin/DemoDataAdmin'));
export const AdminLayout = lazy(() => import('@/components/admin/AdminLayout'));
export const AdminDashboard = lazy(() => import('@/pages/admin/AdminDashboard'));
export const AdminTableBrowser = lazy(() => import('@/pages/admin/AdminTableBrowser'));
export const AdminEntitlements = lazy(() => import('@/pages/admin/AdminEntitlements'));
export const AdminAuditLog = lazy(() => import('@/pages/admin/AdminAuditLog'));

// ---------- Pitch deck pages ----------
export const PitchScreenshots = lazy(() => import('@/pages/PitchScreenshots'));
export const PitchDashboard = lazy(() => import('@/pages/pitch/PitchDashboard'));
export const PitchGMReport = lazy(() => import('@/pages/pitch/PitchGMReport'));
export const PitchVIPProfile = lazy(() => import('@/pages/pitch/PitchVIPProfile'));
export const PitchMarketing = lazy(() => import('@/pages/pitch/PitchMarketing'));
export const PitchIntegrations = lazy(() => import('@/pages/pitch/PitchIntegrations'));
export const PitchStaffing = lazy(() => import('@/pages/pitch/PitchStaffing'));
export const PitchHyped = lazy(() => import('@/pages/pitch/PitchHyped'));
export const PitchInsights = lazy(() => import('@/pages/pitch/PitchInsights'));

// ---------- 404 ----------
export const NotFound = lazy(() => import('@/pages/NotFound'));
